export default {
  meetingsLoaded(state) {
    return state.meetingsLoaded;
  },
  meetings(state) {
    return state.meetings;
  },
};
